import type { EstadoDoRecipiente } from "@plantus/api-client";
import type { EstadoDeAtivo } from "@plantus/ui";

/**
 * O vocabulário de `EstadoDoRecipiente` traduzido para a tela.
 *
 * <h2>Onde mora, e por quê</h2>
 *
 * No setor, não em `packages/ui` — mesmo arranjo de `situacaoDoLote.ts`. O
 * `Selo` não conhece o enum da Produção, e quem escolhe a palavra que aparece
 * no selo é quem desenhou a tela.
 *
 * <h2>O `Record` é metade do controle</h2>
 *
 * `Record<EstadoDoRecipiente, …>` obriga os dois mapas a cobrir <b>todos</b> os
 * valores: acrescentar um estado ao enum sem decidir rótulo e cor quebra o
 * `typecheck`, em vez de produzir um selo mudo em produção. A outra metade é o
 * teste, que confere que a cor sai <b>diferente</b> na tela.
 *
 * <h2>⚠️ Esta é a QUARTA família de cor, e ela não inventou tom nenhum</h2>
 *
 * Status de material responde "este lote pode ser usado?"; situação regulatória
 * responde "este documento cobre esta operação?"; estado do ativo responde
 * <b>"este tambor está em serviço?"</b>. São perguntas diferentes e não se
 * misturam — mas o `dominio.css` diz, com todas as letras, que <b>não sobra
 * tom</b>. Por isso cada estado aponta para um par já medido, e o que separa
 * esta família das outras é o vocabulário e a tela: o estado do ativo nunca
 * aparece na mesma linha de um status de material.
 */

/** A palavra que a pessoa lê — a mesma do glossário. */
export const ROTULO_DO_ESTADO: Record<EstadoDoRecipiente, string> = {
  EM_QUALIFICACAO: "Em qualificação",
  ATIVO: "Ativo",
  BLOQUEADO: "Bloqueado",
  APOSENTADO: "Aposentado",
};

/**
 * A cor.
 *
 * <pre>
 *   EM_QUALIFICACAO  azul     ainda não sabemos — não participa do "pode/não pode"
 *   ATIVO            verde    o único que diz "apto a receber material"
 *   BLOQUEADO        cinza escuro   está aí, inteiro, e ninguém pode usar
 *   APOSENTADO       cinza leve     existe para a rastreabilidade e não decide mais nada
 * </pre>
 */
export const TOM_DO_ESTADO: Record<EstadoDoRecipiente, EstadoDeAtivo> = {
  EM_QUALIFICACAO: "emQualificacao",
  ATIVO: "ativo",
  BLOQUEADO: "bloqueado",
  APOSENTADO: "aposentado",
};

/**
 * O que a tela escreve quando a ocupação não sabe em qual tambor está.
 *
 * <p>Constante, e não texto solto: ela aparece na ficha do volume e na lista de
 * ocupações do mutirão, e duas frases diferentes para a mesma ausência é como
 * uma delas vira "—" na próxima tela.
 */
export const RECIPIENTE_NAO_IDENTIFICADO = "recipiente não identificado";
